export default {"src":"/_next/static/media/disc-types.754ca0b0.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};